var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("p", { staticClass: "p-cjt" }, [
    !_vm.iflogin
      ? _c("span", [
          _c(
            "a",
            {
              staticClass: "ksy-ml-4",
              on: {
                click: function($event) {
                  return _vm.handleClickLink()
                }
              }
            },
            [_vm._v("登录")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "ksy-ml-4",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleClickLink("login?loginType=3")
                }
              }
            },
            [_vm._v("注册")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.iflogin
      ? _c(
          "span",
          [
            _c(
              "a",
              {
                staticClass: "shopping-cart-box",
                attrs: { href: "/client/shoppingCart" }
              },
              [
                _c("img", {
                  attrs: {
                    src:
                      "https://static.xyb2b.com/images/2b5a253a919036981a8d95632a3b60df.svg",
                    width: "20px"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.carNum))])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "shopping-cart-box",
                attrs: { href: "/client/stationLetter" }
              },
              [
                _c("img", {
                  attrs: {
                    src:
                      "https://static.xyb2b.com/images/e6e98c2ab7ff0d5ced033fa5533ad6e3.svg",
                    width: "16px"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.unread))])
              ]
            ),
            _vm._v(" "),
            _c(
              "a-popover",
              {
                attrs: {
                  title: null,
                  trigger: "hover",
                  placement: "bottom",
                  overlayClassName: "usermenubox"
                },
                model: {
                  value: _vm.userMenu,
                  callback: function($$v) {
                    _vm.userMenu = $$v
                  },
                  expression: "userMenu"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "usermenu",
                    attrs: { slot: "content" },
                    slot: "content"
                  },
                  [
                    _c("div", [
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "icon",
                            attrs: {
                              t: "1720693198006",
                              viewBox: "0 0 1024 1024",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "p-id": "6971",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              width: "16",
                              height: "16"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M620.79 195.43H389.25c-0.6 0-1.1-0.49-1.1-1.1V96.35c0-0.6 0.49-1.1 1.1-1.1H620.8c0.6 0 1.1 0.49 1.1 1.1v97.98c-0.01 0.61-0.5 1.1-1.11 1.1z",
                                "p-id": "6972",
                                fill: "#c2c5c6"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M743.12 159.74h-90.99c-1.35 32.91-28.49 59.47-61.73 59.47H419.63c-33.22 0-60.38-26.56-61.73-59.47h-90.98c-50.31 0-91.46 41.15-91.46 91.46v518.3c0 50.3 41.15 91.46 91.46 91.46h476.19c50.31 0 91.46-41.16 91.46-91.46V251.2c0.01-50.31-41.14-91.46-91.45-91.46z m-66.55 512.24h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.63-10.22 22.86-22.86 22.86z m0-139.37h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.63-10.22 22.86-22.86 22.86z m0-139.38h-343.1c-12.64 0-22.86-10.23-22.86-22.86 0-12.64 10.23-22.86 22.86-22.86h343.1c12.64 0 22.86 10.23 22.86 22.86 0.01 12.64-10.22 22.86-22.86 22.86z",
                                "p-id": "6973",
                                fill: "#c2c5c6"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.checkPage("orderList")
                              }
                            }
                          },
                          [_vm._v("我的订单")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.PROCESS_ENV.NODE_PLA === "kby"
                        ? _c("div", { staticClass: "item" }, [
                            _c(
                              "svg",
                              {
                                staticClass: "icon",
                                attrs: {
                                  t: "1720693042906",
                                  viewBox: "0 0 1024 1024",
                                  version: "1.1",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "p-id": "5144",
                                  width: "16",
                                  height: "16",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M46.805333 516.352a469.333333 469.333333 0 1 1 469.333334 469.333333 468.053333 468.053333 0 0 1-469.333334-469.333333z m490.666667 29.866667l115.2 230.4h81.066667l-128-238.933334 25.6-12.8a138.325333 138.325333 0 0 0 55.466666-55.466666 162.133333 162.133333 0 0 0 21.333334-81.066667 176.170667 176.170667 0 0 0-21.333334-81.066667 136.533333 136.533333 0 0 0-55.466666-55.466666 162.602667 162.602667 0 0 0-81.066667-21.333334h-213.333333v546.133334h64v-230.4z m-140.8-64v-192h153.6a85.76 85.76 0 0 1 46.933333 12.8 79.616 79.616 0 0 1 29.866667 34.133333 116.266667 116.266667 0 0 1 12.8 51.2 92.586667 92.586667 0 0 1-12.8 51.2 67.328 67.328 0 0 1-29.866667 29.866667 85.76 85.76 0 0 1-46.933333 12.8z",
                                    "p-id": "5145",
                                    fill: "#c2c5c6"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.checkPage("myBrand")
                                  }
                                }
                              },
                              [_vm._v("我的商标")]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "icon",
                            attrs: {
                              t: "1720693250176",
                              viewBox: "0 0 1024 1024",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "p-id": "8991",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              width: "16",
                              height: "16"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M511.999488 66.861804c-245.825778 0-445.138196 199.284789-445.138196 445.138196 0 245.852384 199.312418 445.137173 445.138196 445.137173 245.880013 0 445.138196-199.284789 445.138196-445.137173C957.137685 266.146593 757.879502 66.861804 511.999488 66.861804zM750.761384 762.417353c-15.377222 0-27.821649-12.443403-27.821649-27.821649 0-116.2834-94.602611-210.886011-210.94127-210.886011-116.2834 0-210.886011 94.603635-210.886011 210.886011 0 15.377222-12.443403 27.821649-27.821649 27.821649s-27.821649-12.443403-27.821649-27.821649c0-117.070322 76.399017-215.667921 181.543729-251.368004-49.502437-29.28907-83.137489-82.675978-83.137489-144.267754 0-92.727914 75.420737-168.17628 168.122045-168.17628s168.123069 75.448366 168.123069 168.17628c0 61.591777-33.580816 114.979708-83.137489 144.267754 105.198947 35.700083 181.597965 134.297682 181.597965 251.368004C778.583033 749.97395 766.138606 762.417353 750.761384 762.417353z",
                                fill: "#c2c5c6",
                                "p-id": "8992"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M511.999488 226.425939c-62.000076 0-112.479771 50.480718-112.479771 112.534006 0 62.026682 50.479695 112.5074 112.479771 112.5074 62.055334 0 112.480794-50.480718 112.480794-112.5074C624.480282 276.905634 574.0538 226.425939 511.999488 226.425939z",
                                fill: "#c2c5c6",
                                "p-id": "8993"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.checkPage("user")
                              }
                            }
                          },
                          [_vm._v("个人信息")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "out hand", on: { click: _vm.loginOut } },
                      [
                        _c("img", {
                          staticClass: "ksy-pb-1 ksy-mt-1",
                          attrs: {
                            src: require("@/assets/images/common/user-out.svg")
                          }
                        }),
                        _vm._v("\n          安全退出\n        ")
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("img", {
                  staticClass: "ksy-mr-2",
                  staticStyle: { width: "34px" },
                  attrs: { src: require("@/assets/images/common/user.png") }
                }),
                _vm._v(" "),
                _vm.nickName !== ""
                  ? _c("span", { staticClass: "hand nickstyle nick" }, [
                      _vm._v(_vm._s(_vm._f("stringSlice")(_vm.nickName, 5)))
                    ])
                  : _vm.account !== ""
                  ? _c("span", { staticClass: "hand nickstyle acc" }, [
                      _vm._v(_vm._s(_vm._f("hideNumber")(_vm.account)))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    style: {
                      width: "10px",
                      height: "10px",
                      marginLeft: "10px",
                      transform:
                        "rotate(" + (_vm.userMenu ? "0" : "180deg") + ")"
                    },
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "9",
                      height: "5",
                      viewBox: "0 0 9 5",
                      fill: "none"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M4.15474 4.9699C4.08122 4.97162 4.00871 4.9525 3.94559 4.91477C3.88247 4.87703 3.83132 4.8222 3.79804 4.75663L0.0901334 0.639018C0.0257221 0.561594 -0.00621923 0.462245 0.00100462 0.361792C0.00822848 0.26134 0.0540567 0.167583 0.128883 0.100175C0.20371 0.0327666 0.301725 -0.00305989 0.402384 0.00020507C0.503043 0.00347003 0.598531 0.0455729 0.668832 0.117689L4.15474 3.9896L7.63999 0.117689C7.71034 0.0455729 7.80581 0.00347003 7.90646 0.00020507C8.00711 -0.00305989 8.10513 0.0327666 8.17997 0.100175C8.2548 0.167583 8.30063 0.26134 8.30787 0.361792C8.31504 0.462245 8.28311 0.561594 8.21869 0.639018L4.51081 4.75476C4.47831 4.81877 4.42871 4.87254 4.3675 4.91007C4.3063 4.94761 4.23589 4.96745 4.16409 4.9674L4.15474 4.9699Z",
                        fill: "#4E5969"
                      }
                    })
                  ]
                )
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f08b7306", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f08b7306","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/UserInfo.vue
// module id = null
// module chunks = 